import { Directive, HostListener, input, output } from '@angular/core';
import { ConfirmMode, DialogService } from '../dialog/index.js';

@Directive({
    selector: '[libConfirm]',
    standalone: false
})
export class ConfirmDirective {
	private readonly _stopPropagation: boolean = true;

	public readonly confirmEnable = input<boolean>(true);
	public readonly confirmText = input<string>();
	public readonly confirmMode = input<ConfirmMode>();

	public readonly confirm = output<void>();

	@HostListener('click', ['$event'])
	onClick($event: Event) {
		if (this._stopPropagation && $event) {
			$event.stopPropagation();
		}
		this.openConfirm();
	}

	constructor(private dialogService: DialogService) {}

	private openConfirm(): void {
		this.dialogService.openConfirmationDialog({
			text: this.confirmText(),
			mode: this.confirmMode(),
			confirm: () => {
				this.confirm.emit();
			}
		});
	}
}
